export class ReadableStore {
    constructor(_value, subscriberFn) {
        this._value = _value;
        this.subscriberFn = subscriberFn;
        this.subscriptors = new Set();
        this.unsubscribeFn = null;
    }
    get value() {
        let value;
        this.subscribe(val => value = val)();
        return value;
    }
    subscribe(sub) {
        const unsubsribe = () => this.unsubscribe(sub);
        if (this.subscriptors.has(sub)) {
            return unsubsribe;
        }
        this.subscriptors.add(sub);
        sub(this._value);
        if (this.subscriptors.size === 1 && this.subscriberFn) {
            this.unsubscribeFn = this.subscriberFn(value => this.updateValue(value));
        }
        return unsubsribe;
    }
    unsubscribe(sub) {
        var _a;
        this.subscriptors.delete(sub);
        if (this.subscriptors.size === 0) {
            (_a = this.unsubscribeFn) === null || _a === void 0 ? void 0 : _a.call(this);
            this.unsubscribeFn = null;
        }
    }
    updateValue(value) {
        this._value = value;
        for (const sub of this.subscriptors) {
            sub(this._value);
        }
    }
}
